import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IVisible } from '..';
import ActionItems from './ActionItems';
import AddLanguageButton from 'components/AddLanguageButton';
import { message } from 'antd';
import { handleMessage } from 'utils/helper/message';
import AddModal from './AddModal';
import { ISupportLanguage } from 'utils/types/storyTypes';
import EditModal from './EditModal';
import { useTranslation } from 'react-i18next';

interface IProps {
  data: any;
  tableData: any;
  setSelectedEl: (value: any) => void;
  visible: IVisible;
  setVisible: React.Dispatch<any>;
  title: string;
  type: string;
  setTitleModal: React.Dispatch<React.SetStateAction<string>>;
  langList: ISupportLanguage[] | null;
  setData: React.Dispatch<any>;
  modalTitle: string;
  setSelectedType: React.Dispatch<React.SetStateAction<string>>;
  selectedType: string;
  projectId: string | undefined;
  selected: any;
}

const Table: React.FC<IProps> = ({
  data,
  tableData,
  setSelectedEl,
  visible,
  setVisible,
  title,
  type,
  setTitleModal,
  langList,
  setData,
  modalTitle,
  setSelectedType,
  selectedType,
  projectId,
  selected,
}) => {
  const { t } = useTranslation();
  const handleAddLanguage = (type) => {
    setSelectedType(type);
    const cloneData = JSON.parse(JSON.stringify(data));
    setTitleModal(
      type === 'section1_localizations'
        ? '프로필 1번 영역 정보 생성'
        : type === 'section2_localizations'
        ? '프로필 2번 영역 정보 생성'
        : type === 'section3_localizations'
        ? '프로필 3번 영역 정보 생성'
        : '프로필 4번 영역 정보 생성',
    );
    if (cloneData[type] && cloneData[type].length > 6) {
      handleMessage(message, 'error', 'Episode only can have 7 languages');
    } else {
      setVisible({ ...visible, create: true });
    }
  };

  return (
    <>
      <SectionWarpper>
        <div className='langsTable'>
          <div className='langsTable-first'>
            <p className='title-table'>Language</p>
          </div>
          <div className='langsTable-second'>
            <p className='title-table'>Label</p>
          </div>
          <div className='langsTable-second'>
            <p className='title-table'>{title}</p>
          </div>
          <div className='langsTable-third'></div>
          {tableData?.map((el, i) => {
            return (
              <>
                <div className='langsTable-first'>
                  <p>{el?.lang}</p>
                </div>
                <div className='langsTable-second'>
                  <p>{el?.label_text}</p>
                </div>
                <div className='langsTable-second'>
                  <p>{el?.profile_text}</p>
                </div>
                <div className='langsTable-third'>
                  <ActionItems
                    data={data}
                    tableData={tableData}
                    elData={el}
                    i={i}
                    setSelectedEl={setSelectedEl}
                    visible={visible}
                    setVisible={setVisible}
                    type={type}
                    setTitleModal={setTitleModal}
                    setData={setData}
                    setSelectedType={setSelectedType}
                  />
                </div>
              </>
            );
          })}
          <AddLanguageButton
            handleAddLanguage={() => handleAddLanguage(type)}
          />
        </div>
      </SectionWarpper>
      <AddModal
        langList={langList}
        data={data}
        setData={setData}
        visible={visible}
        setVisible={setVisible}
        title={title}
        modalTitle={modalTitle}
        selectedType={selectedType}
        projectId={projectId}
      />
      <EditModal
        projectId={projectId}
        langList={langList}
        data={data}
        setData={setData}
        visible={visible}
        setVisible={setVisible}
        selected={selected}
        type={selectedType}
        modalTitle={modalTitle}
      />
    </>
  );
};

export default Table;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
  .langsTable {
    display: flex;
    flex-wrap: wrap;
  }
  .langsTable-first {
    width: 16%;
  }
  .langsTable-second {
    width: 32%;
  }
  .langsTable-third {
    width: 20%;
    display: flex;
    justify-content: end;
    & > * + * {
      margin-left: 16px;
    }
  }
  .langsTable-first,
  .langsTable-second,
  .langsTable-third {
    border-bottom: 1px solid ${theme.colors.dark_200};
    padding: 12px;
    display: flex;
    align-items: center;
    p {
      font-size: ${theme.fontSizes.sm};
      font-style: normal;
      font-weight: ${theme.fontWeights.medium};
      line-height: 16px;
      letter-spacing: 0.2px;
      /* text-transform: capitalize; */
    }
  }
  .title-table {
    font-size: ${theme.fontSizes.normal} !important;
    font-weight: ${theme.fontWeights.bold} !important;
  }
`;
